import React, { useEffect, useState } from 'react';
import PlaceholderLoading from 'react-placeholder-loading';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

import Image from '../components/Image';
import type { Recipe } from '../types/recipes';

const Header = styled.div`
  background: #b0d9f9;
  color: #272b46;
  display: flex;
  justify-content: center;
  padding-top: 20px;
  text-align: center;
`;
const Container = styled.div`
  background: #b0d9f9;
  color: #272b46;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 20px;
  @media screen and (max-width: 900px) {
    padding: 8px 0;
  }
`;
const Result = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  margin: 8px;
  padding: 8px;
  text-align: center;
  align-items: center;
  width: 150px;
  max-height: 150px;
  @media screen and (max-width: 900px) {
    width: 140px;
  }

  :hover {
    box-shadow: 0 0 3px 2px #272b46;
  }
`;
const NoResult = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 1.5em;
  font-weight: 600;
  padding-bottom: 12px;
`;
const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-height: 150px;
  overflow: hidden;
`;
const Placeholder = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 8px;
  padding: 8px;
  align-items: center;
  width: 150px;
  max-height: 150px;
  @media screen and (max-width: 900px) {
    width: 140px;
  }
`;

const SearchResultsPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const search = searchParams.get('q');
  const [recipes, setRecipes] = useState<Array<Recipe>>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (search) {
      setLoading(true);
      fetch(`/api/recipes/search?search=${encodeURIComponent(search)}`)
        .then((response) => response.json())
        .then((data) => {
          setRecipes(data);
          setLoading(false);
        });
    }
  }, [search]);

  return (
    <>
      <Header>
        <h1>Search Results for "{search}"</h1>
      </Header>
      <Container>
        {loading &&
          Array.from({ length: 10 }).map((_, index) => {
            return (
              <Placeholder key={index}>
                <PlaceholderLoading
                  shape="rect"
                  width={140}
                  height={100}
                  colorStart="#e0e0e0"
                  colorEnd="#d0d0d0"
                />
                <PlaceholderLoading
                  shape="rect"
                  width={130}
                  height={12}
                  colorStart="#e0e0e0"
                  colorEnd="#d0d0d0"
                />
              </Placeholder>
            );
          })}
        {!loading &&
          recipes.map((recipe) => {
            return (
              <Result onClick={() => navigate(`/recipe/${recipe._id}`)}>
                <ImageContainer>
                  <Image recipe={recipe} width={recipe.imageId ? 150 : 100} />
                </ImageContainer>
                <span>{recipe.name}</span>
              </Result>
            );
          })}
        {!loading && recipes.length === 0 && (
          <NoResult>
            <img
              alt="No results"
              src="/images/empty_plate.png"
              height="150px"
              width="150px"
            />
            <div>No recipes found</div>
          </NoResult>
        )}
      </Container>
    </>
  );
};

export default SearchResultsPage;
